module.exports = __webpack_public_path__ + "static/media/faq-dropdown.6a9a3ad5.svg";